"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var NpsThankYou = function () {
    return ((0, preact_1.h)("div", { class: 'nps-thankyou' },
        (0, preact_1.h)("p", { class: 'nps-thankyou__title' },
            "Thank you for ",
            (0, preact_1.h)("br", null),
            "sharing your experience!"),
        (0, preact_1.h)("p", { class: 'nps-thankyou__text' },
            "We'd like to offer you ",
            (0, preact_1.h)("b", { class: 'proxima-nova' }, "25% OFF"),
            " your next purchase with code ",
            (0, preact_1.h)("span", { class: 'nps-thankyou__code' }, "SAVE25")),
        (0, preact_1.h)("a", { class: 'nps-thankyou__cta button button--hot-orange', href: '/collections/shop-all' }, "Shop All")));
};
exports.default = NpsThankYou;
